import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {createRequestOption} from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class ObservacionService {

  public resourceUrl = environment.apiUrl + 'comparendo/observacion';

  constructor(public http: HttpClient) {
  }

  create(observacion: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, observacion);
  }

  update(observacion: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, observacion);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, {params: options});
  }

  notEliminate(): Observable<any> {
    return this.http.get<any[]>(this.resourceUrl + '/NotEliminate?page=0&size=50');
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

}
